import API from "@/models/API";

export default class LoyaltyPrograms {
    constructor(item = {}) {
        this.loyalty_program_id = item.loyalty_program_id || undefined;
        this.name = item.name || {};
        this.description = item.description || {};
        this.name.el = item.name?.el || "";
        this.name.en = item.name?.en || "";
        this.name.it = item.name?.it || "";
        this.description.el = item.description?.el || "";
        this.description.en = item.description?.en || "";
        this.description.it = item.description?.it || "";
        this.points_label = item.points_label || "";
        this.logo = item.logo || null;
        this.country_id = item.country_id || null;
        this.active = item.active || false;

    }

    static get = query =>
        API.get(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/loyalties/sub-loyalties${query}`
        );

    static create = body =>
        API.post(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/loyalties/sub-loyalties`,
            body
        );

    static update = (id, body) =>
        API.put(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/loyalties/sub-loyalties/${id}`,
            body
        );

    static uploadLogo = (id, body) =>
        API.post(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/loyalties/sub-loyalties/upload-loyalty-image/${id}`,
            body
        );

    static toggleActive = (id, body) =>
        API.patch(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/loyalties/sub-loyalties/${id}`,
            body
        );

    static delete = id =>
        API.delete(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/loyalties/sub-loyalties/${id}`
        );
}
